import { TradingRepo as tradingRepo } from '../../trading/trading.repo';
import { TradeSheet } from '../../trading/models/tradeSheet';
import { StringUtilities as stringUtilities } from '../../common/string.utilities';
import * as moment from 'moment';
import { DateFilter } from '../models/dateFilters';

class TradeSheetsController implements angular.IOnInit{

  public pendingTradeSheets: Array<TradeSheet>;
  public submittedTradeSheets: Array<TradeSheet>;
  public closedTradeSheets: Array<TradeSheet>;

  public isLoading: boolean;
  public displayAllSheets: boolean = false;
  public loadTradeSheets;
  public tradeSheetOwners: string[];
  public tradeSheetOwner: string;

  public availableStatuses: Array<string> = [];
  public selectedStatusFilter: string;

  private selectedFilter: DateFilter;
  public searchFiltersList: Array<DateFilter>;
  public fromDate;
  public toDate;

  /** @ngInject */
  constructor(private tradingRepo: tradingRepo, private $window: angular.IWindowService, private notifyjs,
    private $scope: angular.IScope, private $mdDialog: angular.material.IDialogService, private $rootScope: angular.IRootScopeService) { }

  $onInit() {
    this.updateTradeSheets();
  }

  $onChanges(changes) {
    if (changes.fromDate || changes.toDate ) {
        this.updateTradeSheets()
    }
    if(changes.loadTradeSheets){
      this.updateTradeSheets()
    }
  }


  public getShortName(text: string) {
    return stringUtilities.truncateText(text, 20);
  }

  filterTradeSets(filter) {
    this.selectedFilter.active = false;
    filter.active = true;
    this.selectedFilter = filter;

    this.updateTradeSheets();
  }

  updateTradeSheets() {
    this.isLoading = true;
    let fromDate = moment(this.fromDate).format('YYYY-MM-DD')
    let toDate = moment(this.toDate).format('YYYY-MM-DD')
    this.tradingRepo.getTradeSheets(fromDate, toDate, this.displayAllSheets)
      .then(res => {

        const data = res.data as Array<any>;

        this.pendingTradeSheets = [];
        this.submittedTradeSheets = [];
        this.closedTradeSheets = [];

        const tradeOwners = new Set<string>();
        data.map(d => new TradeSheet(d))
          .sort((t1, t2) => t1.dateGenerated > t2.dateGenerated ? -1 : 1)
          .forEach(ts => {
            tradeOwners.add(ts.owner);
            if (ts.dateClosed) {
              this.closedTradeSheets.push(ts);
              if (this.availableStatuses.indexOf(ts.status) === -1) {
                this.availableStatuses.push(ts.status);
              }
            } else if (ts.dateSubmitted != null) {
              this.submittedTradeSheets.push(ts);
            } else {
              this.pendingTradeSheets.push(ts);
            }
          });

        this.tradeSheetOwners = Array.from(tradeOwners);
        this.submittedTradeSheets.sort((t1, t2) => t1.dateSubmitted > t2.dateSubmitted ? -1 : 1);
        this.closedTradeSheets.sort((t1, t2) => t1.dateClosed > t2.dateClosed ? -1 : 1);
      })
      .catch(err => this.notifyjs(err.data))
      .finally(() => this.isLoading = false);
  }

  submitTradeSheet($event, tradeSheetId: number) {
    $event.stopPropagation();

    let that = this;
    that.isLoading = true;
    that.tradingRepo.submitTradeSheet(tradeSheetId)
      .then(() => {
        // Update trade sheets will set loading to false;
        that.updateTradeSheets();
      }).catch(err => {
        this.notifyjs(err.data);
      }).finally(() => that.isLoading = false);
  }

  downloadTradeSheet($event, tradeSheetId: number) {
    $event.stopPropagation();

    let that = this;
    that.isLoading = true;
    that.tradingRepo.getDownloadLink(tradeSheetId)
      .then(res => {
        let tradeFiles = res.data as Array<any>;
        tradeFiles.forEach((tradeFile) => {that.$window.open(tradeFile.url, '_blank')});
      })
      .catch(err => {
        this.notifyjs(err.data);
      })
      .finally(() => that.isLoading = false);
  }

  cancelTradeSheet($event, tradeSheet: TradeSheet) {
    $event.stopPropagation();

    // Cancel the tradeSheet
    let that = this;
    const tempScope = that.$rootScope.$new(true) as any;
    tempScope.tradeSheet = tradeSheet;
    that.$mdDialog.show({
      template: `<cancel-trade-sheet-dialog2 trade-sheet="tradeSheet"></cancel-trade-sheet-dialog2>`,
      clickOutsideToClose: true,
      scope: tempScope
    })
      .then((result) => {
        that.updateTradeSheets();
      });
  }

  showTradeSets(tradeSheet: TradeSheet) {
    let that = this;
    if (tradeSheet.portfolioTrades != null) {
      // We've already loaded this data. No need to make another call.
      return;
    }
    that.isLoading = true;
    that.tradingRepo.getTradeSheetPortfolioTrades(tradeSheet.id)
      .then(
        res => {
          tradeSheet.portfolioTrades = res.data as Array<any>;
        }
      )
      .catch(err => {
        this.notifyjs(err.data);
      }
      ).finally(() => that.isLoading = false);
  }

  showTrades(tradeSet: any) {
    let that = this;
    tradeSet.show = !tradeSet.show;
    if (tradeSet.trades == null) {
      that.isLoading = true;
      that.tradingRepo.getTradePreview(tradeSet.tradeSetId)
        .then(res => {
          tradeSet.trades = res.data as Array<any>;
          tradeSet.trades.sort((ts1, ts2) => ts1.security.name > ts2.security.name ? 1 : -1);

          that.isLoading = false;
        }).catch(err => {
          this.notifyjs(err.data);
        }
        ).finally(() => that.isLoading = false);
    }
  }

  showTradeSheetStats(tradeSheet: TradeSheet, excludeProgress?: boolean) {
    if (excludeProgress) {
      let template = `Portfolios: \t${tradeSheet.portfolioCount}`
        + `\nOrders: \t\t${tradeSheet.orderCount}`
        + `\nBuy Quantity: \t${tradeSheet.buyQuantityOrdered}`
        + `\nSell Quantity: \t${tradeSheet.sellQuantityOrdered}`;

      return template;
    }
    else {
      let template =
        `Portfolios completed: \t${tradeSheet.portfoliosCompleted} of ${tradeSheet.portfolioCount}`
        + `\nOrders completed: \t${tradeSheet.ordersCompleted} of ${tradeSheet.orderCount}`
        + `\nBuy processed: \t\t${tradeSheet.buyQuantityProcessed} of ${tradeSheet.buyQuantityOrdered}`
        + `\nSell processed: \t\t${tradeSheet.sellQuantityProcessed} of ${tradeSheet.sellQuantityOrdered}`;

      return template;
    }

  }


  convertToLocaleTime = (date: any) => {
    date = new Date(date)
    return moment(date).local().format('YYYY-MM-DD hh:mm')
  }

}

export const tradeSheets: angular.IComponentOptions = {
  template: require('./tradeSheets.html'),
  controller: TradeSheetsController,
  bindings: {
    isLoading: "<",
    loadTradeSheets: "<",
    fromDate: '<',
    toDate: '<'
  }
};




// WEBPACK FOOTER //
// ./src/app/trading/tradesheets/tradesheets.ts